export const getGoogleUrl = (redirectOrigin) => {
  const rootUrl = `https://accounts.google.com/o/oauth2/v2/auth`;

  const resolveOrigin = (value) => {
    if (!value) return window.location.origin;
    try {
      return new URL(value, window.location.origin).origin;
    } catch (error) {
      return window.location.origin;
    }
  };

  const options = {
    redirect_uri: process.env.REACT_APP_GOOGLE_OAUTH_REDIRECT,
    client_id: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID,
    access_type: 'offline',
    response_type: 'code',
    prompt: 'consent',
    scope: [
      'https://www.googleapis.com/auth/userinfo.profile',
      'https://www.googleapis.com/auth/userinfo.email',
    ].join(' '),
    state: resolveOrigin(redirectOrigin),
  };

  const qs = new URLSearchParams(options);

  return `${rootUrl}?${qs.toString()}`;
};